import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 100%;
  `}
`;

export const Select = styled.div`
  padding: 0;
  position: relative;

  svg {
    position: absolute;
    right: 0;
    bottom: 4px;
  }
`;

export const InputSearch = styled.input`
  ${({ theme }) => css`
    position: relative;
    border: none;
    border-bottom: 1px solid #ddd;
    width: 100%;

    font-weight: 500;
    padding-top: 2.2rem;
    color: ${theme.colors.gray};
    font-size: 1.4rem;
    font-family: Roboto !important;

    &:placeholder {
      font-weight: 400;
      color: ${theme.colors.gray};
      font-size: 1.4rem;
      font-family: Roboto !important;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: ${theme.font.sizes.small};
    margin-bottom: 0.3rem;
    font-weight: bold;
    letter-spacing: 0.3rem;
  `}
`;

export const Options = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: absolute;
    border: 1px solid gray;
    width: 100%;
    padding: 0rem 1rem;
    max-height: 10rem;
    overflow: auto;
    z-index: 9999999;
    background-color: ${theme.colors.white};
  `}
`;

export const Option = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    padding: 1rem 0;

    border-bottom: 1px solid #ddd;
    &:last-child {
      border: none;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.blackSecondary};
    font-size: ${theme.font.sizes.xsmall};
  `}
`;

export const Selected = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
